import React from 'react';
import { FiCopy } from 'react-icons/fi';
import { Box, Button, ConfigSnippet } from 'core/components';

import CopyToClipboardButton from 'app/components/CopyToClipboardButton';

const ScriptDisplay = ({ source, data, noCopy = false }) => {
  if (noCopy) {
    return (
      <Box mb={2} mt={2}>
        <ConfigSnippet source={source} data={data} themeName="steel" p={2}>
          {({ snippet }) => (
            <Box position="relative" width={754}>
              {snippet}
            </Box>
          )}
        </ConfigSnippet>
      </Box>
    );
  }
  return (
    <Box mb={2} mt={2}>
      <ConfigSnippet source={source} data={data} themeName="steel" p={2}>
        {({ snippet, rawContent }) => (
          <Box position="relative">
            <CopyToClipboardButton text={rawContent} intent="none">
              <Button icon={FiCopy} title="Copy to Clipboard" position="absolute" top="10px" right="16px" />
            </CopyToClipboardButton>
            {snippet}
          </Box>
        )}
      </ConfigSnippet>
    </Box>
  );
};

export default ScriptDisplay;
